module.exports = __webpack_public_path__ + "img/avatar.d99a9dff.png";